import React, { useMemo } from 'react';
import { tabComponents } from './config';
import { useApplicantEvaluation } from './context';
import { useTranslations } from '../context/TranslationContext';
import Header from './Header';
import Loading from './Loading';
import './index.less';
import ApplicantHeartRating from '../ApplicantHeartRating';

const ApplicantEvaluation = () => {
    const { t } = useTranslations();
    const { activeTab, loading, onChangeStepHandler, step, steps, sections, setActiveTab, onEvaluationUpdated, applicantInfo, ...rest } =
        useApplicantEvaluation();
    const { ratings } = applicantInfo;

    const renderComponent = (id) => {
        const { component, keys } = tabComponents[id] || {};
        if (!component) return <div>{t('Unable to render data')}</div>;
        const data = keys.reduce((acc, key) => {
            acc[key] = rest[key];
            return acc;
        }, {});
        return (
            <React.Suspense fallback={t('Loading')}>
                {React.createElement(component, data)}
            </React.Suspense>
        );
    };

    const showEvaluations = useMemo(() => {
        return !loading && steps.length > 0;
    }, [loading, steps]);


    const renderEvaluations = () => {
        if (steps.length === 0) {
            return <h5 className='text-center no-data-placeholder'>{t('No evaluations found for any recruitment steps.')}</h5>;
        }
        return <>
            <Header
                steps={steps}
                step={step}
                sections={sections}
                onChangeTab={(tab) => setActiveTab(tab)}
                onChangeStep={onChangeStepHandler}
            />
            {renderComponent(activeTab)}
        </>;
    }
    return (
        <div className='applicant-evaluation-container'>
            {ratings?._links && <ApplicantHeartRating context={ratings} onUpdate={onEvaluationUpdated} />}
            {loading ? <Loading /> : renderEvaluations()}
        </div>
    );
};

export default ApplicantEvaluation;
